import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ContentEditor from '../../ContentEditor';
import { ContentSection, QuestionWrapper } from '../styles';

const EvaluationContentEditor = ({ children, data, payload, setPayload, type, fileService, loading = false }) => {
  const [placeholder, setPlaceholder] = useState(data.placeholder || '');

  useEffect(() => {
    if (data.placeholder !== placeholder) {
      setPayload({ ...payload, placeholder, immediateSave: false });
    }
  }, [placeholder]);

  const questionEditor = (
    <ContentEditor
      id="questionEditor"
      type={type}
      aria-label={i18n.__('evaluation_question_placeholder')}
      placeholder={i18n.__('evaluation_question_placeholder')}
      value={placeholder}
      onChange={(value) => !loading && setPlaceholder(value)}
      fileService={fileService}
      canToggleToolbar={false}
      showToolbar={true}
      loading={loading}
      theme="bubble"
      toolbar={[['bold', 'italic', 'underline'], ['image']]}
    />
  );

  return (
    <ContentSection>
      {children}
      <hr />
      <QuestionWrapper>{questionEditor}</QuestionWrapper>
    </ContentSection>
  );
};

export default EvaluationContentEditor;

EvaluationContentEditor.propTypes = {
  children: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  payload: PropTypes.object.isRequired,
  setPayload: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  fileService: PropTypes.object.isRequired,
  loading: PropTypes.bool,
};
